import { render, staticRenderFns } from "./scientific-management.vue?vue&type=template&id=498b478e&scoped=true"
import script from "./scientific-management.vue?vue&type=script&lang=ts"
export * from "./scientific-management.vue?vue&type=script&lang=ts"
import style0 from "./scientific-management.vue?vue&type=style&index=0&id=498b478e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b478e",
  null
  
)

export default component.exports